export function escapeRegexChars(str: string): string {
  return str.replace(/[.^$*+?()[{\\|]/g, match => `\\${match}`);
}
